import { Badge as PrimeBadge } from 'primereact/badge';
import styles from './Badge.module.css';

export default function Badge({ children, background, color }) {
  return (
    <PrimeBadge value={children} className={styles.badge} style={{ background, color }} />
  );
}
